import ReactQuill from 'react-quill';
import { modules } from '../../../../utils/quillModules';
import { formats } from '../../../../utils/quillFormats';
import CharCount from '../../../charCount/CharCount';
import DirectInput from '../../../directInput/DirectInput';
import TimePicker from '../../../reusable-ui-components/TimePicker';
import styles from './activityBasic.module.css';
import { forwardRef } from 'react';
import useSectionHighlightRef from '../../../../hooks/useSectionHighlightRef';

const ActivityBasic = forwardRef(({ activityData, setActivityData, isEdit, isSupport }, ref) => {
    const { sectionRef, highlightField } = useSectionHighlightRef(ref);
    return (
        <div ref={sectionRef}>
            {isEdit ? (
                <h1 className='orgPackUpH1'>Edit Activity</h1>
            ) : (
                <h1 className='orgPackUpH1'>Create New Activity</h1>
            )}
            <div className={styles.orgPackUpSecDiv}>
                <DirectInput
                    label='Title'
                    name='title'
                    value={activityData.title}
                    type='text'
                    placeholder='Title'
                    setFormData={setActivityData}
                    min={3}
                    limit={50}
                    disabled={
                        !isSupport && isEdit && activityData.status !== 'inactive' && activityData.status !== 'rejected'
                    }
                    error={highlightField === 'title'}
                />
                <div className='itineraryDiv'>
                    <label className='itineraryLabel'>Overview</label>
                    <div className='itineraryDescDiv'>
                        <ReactQuill
                            name='overview'
                            value={activityData.overview}
                            onChange={(e) =>
                                setActivityData((prevState) => {
                                    return { ...prevState, overview: e };
                                })
                            }
                            theme='snow'
                            placeholder='Overview'
                            className={`${highlightField === 'overview' ? 'error-highlight' : ''}`}
                            readOnly={
                                isEdit && activityData.status !== 'inactive' && activityData.status !== 'rejected'
                            }
                            modules={modules}
                            formats={formats}
                        />
                        <CharCount string={activityData.overview ? activityData.overview : ''} min={50} limit={4000} />
                    </div>
                </div>
                <div className={styles.timeSlotsInDiv}>
                    <label className={styles.timeSlotsLabel}>Opening Time</label>
                    <div className={styles.timeSlotsInputDiv}>
                        <TimePicker
                            value={activityData.openTime}
                            onChange={(getTimeValue) => {
                                setActivityData((prev) => ({
                                    ...prev,
                                    openTime: getTimeValue
                                }));
                            }}
                            error={highlightField === 'openTime'}
                        />
                    </div>
                </div>
                <div className={styles.timeSlotsInDiv}>
                    <label className={styles.timeSlotsLabel}>Closing Time</label>
                    <div className={styles.timeSlotsInputDiv}>
                        <TimePicker
                            value={activityData.closeTime}
                            onChange={(getTimeValue) => {
                                setActivityData((prev) => ({
                                    ...prev,
                                    closeTime: getTimeValue
                                }));
                            }}
                            error={highlightField === 'closeTime'}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
});

export default ActivityBasic;
